import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 33,
	viewBox: "0 0 24 33",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.0482 1.21987C12.4719 0.593377 11.5281 0.593377 10.9518 1.21987L1.17399 11.8484C0.608669 12.463 0.608669 13.4513 1.17399 14.0658C1.75034 14.6923 2.69411 14.6923 3.27045 14.0658L10.5278 6.17704L10.5278 30.6714C10.5278 31.5232 11.1677 32.25 12 32.25C12.8323 32.25 13.4722 31.5232 13.4722 30.6714L13.4722 6.17704L20.7295 14.0658C21.3059 14.6923 22.2497 14.6923 22.826 14.0658C23.3913 13.4513 23.3913 12.463 22.826 11.8484L13.0482 1.21987Z",
		fill: "var(--color-icon-contrast-500)"
	})
});
const ForwardRef = forwardRef(SvgArrowUp);
export default ForwardRef;
